import React from "react";
import {h, Component } from "preact";

export default class ImagePreview extends Component {
    state = {
        open: false,
    };
    render() {
        const { src } = this.props;

        return (
            <div>
                <a onClick={() => this.setState({open: true})}>
                    <img
                        className="img-fluid"
                        src={src}
                        alt=""
                    />
                </a>
                {
                    this.state.open &&  <div className={"image-preview"}>
                        <button type="button" onClick={() => this.setState({open: false})} className="close" aria-label="Close">×</button>
                        <img
                            onClick={() => this.setState({open: false})}
                            className="img-fluid"
                            src={src}
                            alt=""
                        />
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/widget/ImagePreview.js